import script from "./ComissionForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ComissionForm.vue?vue&type=script&setup=true&lang=js"

export default script